// extracted by mini-css-extract-plugin
export default {"img":"Image_img__hncPr"};